const React = require("react");

function SwitchVerticalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
  }));
}

module.exports = SwitchVerticalIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/SwitchVerticalIcon.js
 ** module id = 624
 ** module chunks = 0
 **/